module.exports = __webpack_public_path__ + "static/media/heroku.5f37a5b5.svg";